import { useCallback } from 'react';

type UseMobileSortSelectorProps = {
	// FIXME(SelectMenu): Using string | number because the component requires Key type from react-aria as value
	changeSelection: (value: string | number) => void;
};

type Result = ModelHookResult<
	undefined,
	{
		// FIXME(SelectMenu): Using string | number because the component requires Key type from react-aria as value
		updateSort: (value: string | number) => void;
	}
>;

export function useMobileSortSelector({ changeSelection }: UseMobileSortSelectorProps): Result {
	const updateSort = useCallback(
		(value: string | number) => {
			changeSelection(value);
		},
		[changeSelection],
	);

	return {
		actions: {
			updateSort,
		},
	};
}
